import { OwAccordion } from "@components/shared/OwAccordion/OwAccordion";
import OwSelectOption from "@components/shared/OwSelectOption/OwSelectOption";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import WhatsThis from "@components/shared/WhatsThis/WhatsThis";
import SupplierContext from "@contexts/SupplierContext";
import ICatalog from "@models/ICatalog";
import TitleTagEnum from "@models/TitleTagEnum";
import { isString } from "lodash-es";
import React, { useContext, useState } from "react";

type Props = {
    handleChange: (e: React.ChangeEvent<any>) => void;
    borderClass: string;
    catalogs: ICatalog[];
};

export const QuickbooksDesktopConfigSalesOrdersSection = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const { qbd_Templates } = supplierModel.Supplier_Integration;

    const [supplierIntegration, setSupplierIntegration] = useState({
        qbd_SO_TemplateRef: supplierModel.Supplier_Integration.qbd_SO_TemplateRef,
        qbd_UseOWOrderNoForSO: supplierModel.Supplier_Integration.qbd_UseOWOrderNoForSO || false,
        qbd_sales_order_use_order_ship_to: supplierModel.Supplier_Integration.qbd_sales_order_use_order_ship_to || false,
    });

    const templateOptions = isString(qbd_Templates) ? JSON.parse(qbd_Templates || "") : qbd_Templates || [];

    const handleChange = (e: React.ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const updatedSupplierIntegration = {
            ...supplierIntegration,
            [name]: value,
        };

        setSupplierIntegration(updatedSupplierIntegration);

        props.handleChange(e);
    };

    return (
        <div className={"QuickbooksDesktopConfigSalesOrdersSection mb-2"}>
            <OwAccordion title={"sales_orders"} fullWidthClick={true} titleTag={TitleTagEnum.H5}>
                <div className={"col-12 card " + props.borderClass} data-id={"qbd-sales-orders-card"}>
                    <div className="card-header">
                        <OwTitle title={"sales_orders"} isBold={true} tag={"h5"} />
                    </div>

                    <div className="card-body">
                        <div className={""}>
                            <OwTitle title={"template"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"qbd_sales_order_template_info"} />
                            <div>
                                <OwSelectOption
                                    valueProp={"ListID"}
                                    fn={handleChange}
                                    name={"qbd_SO_TemplateRef"}
                                    options={templateOptions}
                                    titleProp={"Name"}
                                    selectedOption={supplierIntegration}
                                    selectedOptionProp={"qbd_SO_TemplateRef"}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwTitle title={"options"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"qbd_use_orderwerks_order_no_info"} />
                            <div>
                                <OwToggle
                                    fn={handleChange}
                                    name={"qbd_UseOWOrderNoForSO"}
                                    label={"use_orderwerks_order_no_as_sales_order_no"}
                                    active={supplierIntegration.qbd_UseOWOrderNoForSO || false}
                                    labelOnRight={true}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwToggle
                                fn={handleChange}
                                name={"qbd_sales_order_use_order_ship_to"}
                                label={"sales_order_use_order_ship_to"}
                                active={supplierIntegration.qbd_sales_order_use_order_ship_to || false}
                                labelOnRight={true}
                            />
                        </div>
                    </div>
                </div>
            </OwAccordion>
        </div>
    );
};
